import type { PropsWithChildren } from "react";
import {
  EMPTY_CONTEXT_VALUES,
  PortalContextBridgeScopeContext,
  type PortalContextValues,
} from "#portal-context-bridge-scope-context";

/**
 * Place below a portal transport provider, above the app contexts to forward.
 * Transport state must never be captured by the content it transports: doing so
 * subscribes the publisher to its own updates and retains previous portal trees.
 * A nested transport can explicitly inherit app contexts captured before it.
 */
export function PortalContextBridgeScope({
  children,
  inheritedValues = EMPTY_CONTEXT_VALUES,
}: PropsWithChildren<{ inheritedValues?: PortalContextValues }>) {
  return (
    <PortalContextBridgeScopeContext value={inheritedValues}>
      {children}
    </PortalContextBridgeScopeContext>
  );
}
